import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.292 12.058c.52-5.914 5.736-10.287 11.65-9.767 5.914.52 10.287 5.736 9.767 11.65-.52 5.915-5.736 10.288-11.65 9.768-5.914-.52-10.287-5.736-9.767-11.65Zm11.893-3.973a.75.75 0 1 0-1.494-.132l-.525 5.977a.75.75 0 0 0 1.494.132l.525-5.977Zm-1.47 8.152a1.25 1.25 0 1 0-.218 2.49 1.25 1.25 0 0 0 .219-2.49Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgComponent
